import { TTrackAction } from "./trackActions";
import { ITrackContextValue } from "./trackContextInterface";
import { getDefaultTrackSelection } from "./trackInitialState";

// any action update depends on useReducerType.ts
export const reducer = (state: ITrackContextValue, action: TTrackAction) => {
  switch (action.type) {
    case "SET_IS_ANY_ITEMS_AVAILABLE_IN_CART":
      return {
        ...state,
        isAnyItemsAvailableInCart: action.payload.isAnyItemsAvailableInCart,
      };
    case "SET_IS_CUSTOMER_LOGGED_IN":
      return {
        ...state,
        customerInfo: {
          customerPostalCode: action.payload.customerInfo.customerPostalCode,
          isCustomerLogged: action.payload.customerInfo.isCustomerLogged,
          isCustomerActiveSubscriber: action.payload.customerInfo.isCustomerActiveSubscriber,
        },
      };
    case "SET_VISITOR_LOCATION":
      return {
        ...state,
        visitorLocation: action.payload.visitorLocation,
      };
    case "SET_MEMBERSHIP_INFO":
      return {
        ...state,
        membershipInfo: {
          ...state.membershipInfo,
          ...action.payload.membershipInfo,
        },
      };
    case "SET_CART_INFORMATION":
      return {
        ...state,
        headlessCartInfo: {
          id: action.payload.cart.id,
          checkoutUrl: action.payload.cart.checkoutUrl,
        },
      };
    case "SET_PRODUCT_RENDER_LOCATION":
      return {
        ...state,
        productRenderedLocation: action.payload.productRenderedLocation,
      };
    case "SET_APP_HOSTED_AT":
      return {
        ...state,
        appHostedAt: action.payload.appHostedAt,
      };
    case "SET_CARTITEMS_HEADLESS":
      return {
        ...state,
        headlessCart: [...action.payload.headlessCart],
      };
    case "SET_HEADLESS_CART_REMOVE_ITEM":
      return {
        ...state,
        headlessCartRemoveItem: {
          displayCartComfirmationPopup: action.payload.headlessCartRemoveItem.displayCartComfirmationPopup,
          shouldItemRemove: action.payload.headlessCartRemoveItem.shouldItemRemove,
          ItemId: action.payload.headlessCartRemoveItem.ItemId,
        },
      };
    case "SET_HEADLESS_CART_TOTAL_AMOUNT":
      return {
        ...state,
        headlessCartTotalAmount: action.payload.headlessCartTotalAmount,
      };
    case "SET_HEADLESS_IS_MINI_CART_SHOWING":
      return {
        ...state,
        isHeadlessMiniCartIsShowing: action.payload.isHeadlessMiniCartIsShowing,
      };
    case "SET_NEWSLETTER_SUBSCRIPTION":
      return {
        ...state,
        isNewsletterSubscripted: action.payload.isNewsletterSubscripted,
      };
    case "SET_TERMS_AND_CONDITION":
      return {
        ...state,
        mainTrackSelection: {
          ...state.mainTrackSelection,
          isTermsAndConditionExcepted: action.payload.isTermsAndConditionExcepted,
        },
      };
    case "SET_NOTIFICATION":
      return {
        ...state,
        notification: {
          title: action.payload.title,
          content: action.payload.content,
          isVisible: action.payload.isVisible,
          variant: action.payload.variant,
        },
      };
    case "SET_SELECTED_TRACK":
      return {
        ...state,
        trackSelectionOption: {
          title: action.payload.selectedTrackTitle,
          trackBanner: action.payload.trackBanner,
        },
      };
    case "RESET_SELECTED_TRACK":
      return {
        ...state,
        trackSelectionOption: getDefaultTrackSelection("/"),
      };
    case "SET_MAIN_TRACK_SELECTION_BY_AGE_GROUP":
      return {
        ...state,
        mainTrackSelectionByAgeGroup: action.payload.selectionsByAgeGroup,
      };
    case "SET_AGE_GROUP": {
      const shouldClearSelections = action.payload.ageGroup !== state.mainTrackSelection.ageGroup;
      return {
        ...state,
        mainTrackSelection: {
          ...state.mainTrackSelection,
          ageGroup: action.payload.ageGroup,
          // Only clear selections when the age group actually changes
          variantsAndDate: shouldClearSelections
            ? {
                ...state.mainTrackSelection.variantsAndDate,
                selectedVariants: [],
                selectedVariantsForUpsell: [],
              }
            : state.mainTrackSelection.variantsAndDate,
        },
      };
    }
    case "SET_SEARCHED_DATE_WITH_NO_AVAILABLE_VARIANTS":
      return {
        ...state,
        mainTrackSelection: {
          ...state.mainTrackSelection,
          disableDatesForUnderSixteenAgeGroup: action.payload.disableDatesForUnderSixteenAgeGroup,
        },
      };
    case "SET_SHOW_DISPLAY_POPUP":
      return {
        ...state,
        mainTrackSelection: {
          ...state.mainTrackSelection,
          displayPopup: action.payload.showPopupForSixteenPlus,
        },
      };
    case "SET_SHOW_INFORMATION_POPUP":
      return {
        ...state,
        mainTrackSelection: {
          ...state.mainTrackSelection,
          showInformationPopup: action.payload.showInformationPopup,
        },
      };
    case "SET_RACE_TYPE":
      return {
        ...state,
        mainTrackSelection: {
          ...state.mainTrackSelection,
          raceType: action.payload.raceType,
          // Clear selected variants when race type changes as they may no longer be valid
          variantsAndDate: {
            ...state.mainTrackSelection.variantsAndDate,
            selectedVariants: [],
            selectedVariantsForUpsell: [],
          },
        },
      };
    case "SET_RACES_SEATS":
      return {
        ...state,
        mainTrackSelection: {
          ...state.mainTrackSelection,
          racesSeats: {
            numberOfSeats: action.payload.racesSeats.numberOfSeats,
            numberOfRaces: action.payload.racesSeats.numberOfRaces,
          },
        },
      };
    case "SET_DATE_AND_VARIANT":
      return {
        ...state,
        mainTrackSelection: {
          ...state.mainTrackSelection,
          variantsAndDate: {
            selectedSessionTime: action.payload.variantsAndDate.selectedSessionTime,
            selectedDate: action.payload.variantsAndDate.selectedDate,
            selectedVariants: action.payload.variantsAndDate.selectedVariants,
            selectedVariantsForUpsell: action.payload.variantsAndDate.selectedVariantsForUpsell,
          },
        },
      };
    case "SET_IS_CART_EMPTY":
      return {
        ...state,
        isCartEmpty: action.payload.isCartEmpty,
      };
    case "SET_DATE_AND_VARIANT_MINI_TRACK":
      return {
        ...state,
        miniTrackSection: {
          ...state.miniTrackSection,
          variantsAndDate: {
            selectedSessionTime: action.payload.variantsAndDate.selectedSessionTime,
            selectedDate: action.payload.variantsAndDate.selectedDate,
            selectedVariants: action.payload.variantsAndDate.selectedVariants,
            selectedVariantsForUpsell: action.payload.variantsAndDate.selectedVariantsForUpsell,
          },
        },
      };
    case "SET_DATE_AND_VARIANT_JUNIOR_TRACK":
      return {
        ...state,
        juniorTrackSelection: {
          ...state.juniorTrackSelection,
          variantsAndDate: {
            selectedSessionTime: action.payload.variantsAndDate.selectedSessionTime,
            selectedDate: action.payload.variantsAndDate.selectedDate,
            selectedVariants: action.payload.variantsAndDate.selectedVariants,
            selectedVariantsForUpsell: action.payload.variantsAndDate.selectedVariantsForUpsell,
          },
        },
      };
    case "SET_DATE_AND_VARIANT_INTERMEDIATE_TRACK":
      return {
        ...state,
        intermediateTrackSelection: {
          ...state.intermediateTrackSelection,
          variantsAndDate: {
            selectedSessionTime: action.payload.variantsAndDate.selectedSessionTime,
            selectedDate: action.payload.variantsAndDate.selectedDate,
            selectedVariants: action.payload.variantsAndDate.selectedVariants,
            selectedVariantsForUpsell: action.payload.variantsAndDate.selectedVariantsForUpsell,
          },
        },
      };
    case "SET_DATE_AND_VARIANT_BATTLE_KART_TRACK":
      return {
        ...state,
        battleKartSelection: {
          ...state.battleKartSelection,
          variantsAndDate: action.payload.variantsAndDate,
        },
      };
    case "SET_RACES_SEATS_MINI_TRACK":
      return {
        ...state,
        miniTrackSection: {
          ...state.miniTrackSection,
          racesSeats: {
            numberOfSeats: action.payload.racesSeats.numberOfSeats,
            numberOfRaces: action.payload.racesSeats.numberOfRaces,
          },
        },
      };
    case "SET_TERMS_AND_CONDITION_MINI_TRACK":
      return {
        ...state,
        miniTrackSection: {
          ...state.miniTrackSection,
          isTermsAndConditionExcepted: action.payload.isTermsAndConditionExcepted,
        },
      };
    case "SET_TERMS_AND_CONDITION_JUNIOR_TRACK":
      return {
        ...state,
        juniorTrackSelection: {
          ...state.juniorTrackSelection,
          isTermsAndConditionExcepted: action.payload.isTermsAndConditionExcepted,
        },
      };
    case "SET_TERMS_AND_CONDITION_INTERMEDIATE_TRACK":
      return {
        ...state,
        intermediateTrackSelection: {
          ...state.intermediateTrackSelection,
          isTermsAndConditionExcepted: action.payload.isTermsAndConditionExcepted,
        },
      };
    case "SET_TERMS_AND_CONDITION_BATTLE_KART":
      return {
        ...state,
        battleKartSelection: {
          ...state.battleKartSelection,
          isTermsAndConditionExcepted: action.payload.isTermsAndConditionExcepted,
        },
      };
    case "SET_ARCADE_GAME_SELECTION":
      return {
        ...state,
        arcadeSelection: {
          ...state.arcadeSelection,
          arcadeGameChoose: {
            ...state.arcadeSelection.arcadeGameChoose,
            isProductOutOfStock: action.payload.isProductOutOfStock,
            selectedVariantId: action.payload.selectedVariantId,
            selectedArcadeGame: action.payload.arcadeGameSelection,
          },
        },
      };
    case "SET_ARCADE_GAME_QUANTITY":
      return {
        ...state,
        arcadeSelection: {
          ...state.arcadeSelection,
          arcadeGameChoose: {
            ...state.arcadeSelection.arcadeGameChoose,
            selectedQuantity: action.payload.selectedQuantity,
          },
        },
      };
    case "SET_TERMS_AND_CONDITIONS_CONTENT":
      return {
        ...state,
        termsAndConditionsContent: action.payload.termsAndConditionsContent,
      };
    case "SET_MAIN_TRACK_UPSELL_IMAGE_ID_FROM_METAOBJECT":
      return {
        ...state,
        mainTrackUpsellImageIds: action.payload.mainTrackUpsellImageIds,
      };
    case "SET_MAIN_TRACK_UPSELL_IMAGE_URLS":
      return {
        ...state,
        mainTrackUpsellImageUrls: action.payload.mainTrackUpsellImageUrls,
      };
    case "SET_MINI_TRACK_UPSELL_IMAGE_ID_FROM_METAOBJECT":
      return {
        ...state,
        miniTrackUpsellImageIds: action.payload.miniTrackUpsellImageIds,
      };
    case "SET_MINI_TRACK_UPSELL_IMAGE_URLS":
      return {
        ...state,
        miniTrackUpsellImageUrls: action.payload.miniTrackUpsellImageUrls,
      };
    case "SET_PROGRESSIVE_BAR_BREADCRUMBS_ROUTE":
      return {
        ...state,
        progressiveBarBreadcrumbsRoutes: action.payload.progressiveBarBreadcrumbsRoutes,
      };
    case "SET_WINDOW_WIDTH":
      return {
        ...state,
        windowWidth: action.payload.windowWidth,
      };
    case "SET_METAOBJECT_TRACK_SELECTION_CONFIG":
      return {
        ...state,
        metaObjectTrackSelectionConfig: action.payload.metaObjectTrackSelectionConfig,
      };
    case "SET_BOTTOM_SUMMARY_CONFIG":
      return {
        ...state,
        bottomSummaryConfig: action.payload.bottomSummaryConfig,
      };
    case "SET_DATE_TIME_CONFIG":
      return {
        ...state,
        dateTimeConfig: action.payload.dateTimeConfig,
      };
    case "SET_DAY_TYPE_INTERVALS":
      return {
        ...state,
        dayTypeIntervals: action.payload.dayTypeIntervals,
      };
    case "SET_METAOJECT_MAIN_TRACK_CONFIG":
      return {
        ...state,
        metaObjectMainTrackSectionConfig: action.payload.metaObjectMainTrackSectionConfig,
      };
    case "SET_METAOJECT_JUNIOR_TRACK_CONFIG":
      return {
        ...state,
        metaObjectJuniorTrackSectionConfig: action.payload.metaObjectJuniorTrackSectionConfig,
      };
    case "SET_METAOJECT_INTERMEDIATE_TRACK_CONFIG":
      return {
        ...state,
        metaObjectIntermediateTrackSectionConfig: action.payload.metaObjectIntermediateTrackSectionConfig,
      };
    case "SET_METAOJECT_MINI_TRACK_CONFIG":
      return {
        ...state,
        metaObjectMiniTrackSectionConfig: action.payload.metaObjectMiniTrackSectionConfig,
      };
    case "SET_METAOJECT_UPSELL_MODAL_CONFIG":
      return {
        ...state,
        upsellModalConfig: action.payload.upsellModalConfig,
      };
    case "SET_RACES_SEATS_JUNIOR_TRACK":
      return {
        ...state,
        juniorTrackSelection: {
          ...state.juniorTrackSelection,
          racesSeats: action.payload.racesSeats,
        },
      };
    case "SET_RACES_SEATS_INTERMEDIATE_TRACK":
      return {
        ...state,
        intermediateTrackSelection: {
          ...state.intermediateTrackSelection,
          racesSeats: action.payload.racesSeats,
        },
      };
    case "SET_METAOJECT_BATTLE_KART_TRACK_CONFIG":
      return {
        ...state,
        metaObjectBattleKartTrackSectionConfig: action.payload.metaObjectBattleKartTrackSectionConfig,
      };
    case "SET_RACES_SEATS_BATTLE_KART_TRACK":
      return {
        ...state,
        battleKartSelection: {
          ...state.battleKartSelection,
          racesSeats: action.payload.racesSeats,
        },
      };
    case "SET_IS_FIRST_VISIT":
      return {
        ...state,
        isFirstVisit: action.payload.isFirstVisit,
      };
    case "SET_HAS_PROVIDED_POSTCODE":
      return {
        ...state,
        hasProvidedPostcode: action.payload.hasProvidedPostcode,
      };
    case "SET_SHOPIFY_CART_VARIANTS":
      return {
        ...state,
        shopifyCartVariants: action.payload.shopifyCartVariants,
      };
    case "SET_IS_SHOPIFY_CART_VARIANTS_LOADING":
      return {
        ...state,
        isShopifyCartVariantsLoaded: action.payload.isShopifyCartVariantsLoaded,
      };
    case "SET_IS_IN_CART_MODE":
      return {
        ...state,
        isInCartMode: action.payload.isInCartMode,
      };
    case "SET_PRODUCT_LOADING":
      return {
        ...state,
        isProductLoading: action.payload.isProductLoading,
      };
    case "SET_IS_PROCESSING_ADD_TO_CART":
      return {
        ...state,
        isProcessing: action.payload.isProcessing,
        processingType: action.payload.processingType,
      };
    case "SET_COLLECTION_PRODUCTS":
      return {
        ...state,
        collectionProducts: action.payload.collectionProducts,
      };
    case "SET_SHOW_ARCADE_BANNER":
      return {
        ...state,
        showArcadeBanner: action.payload.showArcadeBanner,
      };
    case "SET_HAS_SUMMARY_BEEN_AUTO_SHOWN":
      return {
        ...state,
        hasSummaryBeenAutoShown: action.payload.hasSummaryBeenAutoShown,
      };
    case "SET_IS_SUMMARY_EXPANDED":
      return {
        ...state,
        isSummaryExpanded: action.payload.isSummaryExpanded,
      };
    case "SET_MULTI_TRACK_QUEUE":
      return {
        ...state,
        multiTrackQueue: {
          entries: action.payload.entries,
          currentIndex: 0,
        },
      };
    case "ADVANCE_MULTI_TRACK":
      return {
        ...state,
        multiTrackQueue: {
          ...state.multiTrackQueue,
          currentIndex: state.multiTrackQueue.currentIndex + 1,
        },
      };
    case "CLEAR_MULTI_TRACK_QUEUE":
      return {
        ...state,
        multiTrackQueue: {
          entries: [],
          currentIndex: 0,
        },
      };
    case "SET_NAVIGATION_PREVIOUS_INFO":
      return {
        ...state,
        navigationPreviousInfo: action.payload.navigationPreviousInfo,
      };
    case "SET_BOTTOM_SUMMARY_NAV":
      return {
        ...state,
        bottomSummaryNav: action.payload.bottomSummaryNav,
      };
    default:
      return state;
  }
};
